// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"515":"9f49fbc1","627":"9df95545","717":"5d538c57","925":"2e09678a"}[chunkId] + ".chunk.css";
};